import { render } from "./NotificationView.vue?vue&type=template&id=8d5d5258"
import script from "./NotificationView.vue?vue&type=script&lang=js"
export * from "./NotificationView.vue?vue&type=script&lang=js"

import "./NotificationView.vue?vue&type=style&index=0&id=8d5d5258&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__